module.exports = __webpack_public_path__ + "static/img/hire2.e24fad8.png";


//////////////////
// WEBPACK FOOTER
// ./static/hire/hire2.png
// module id = ihVW
// module chunks = 1